import { render, staticRenderFns } from "./LevelBar.vue?vue&type=template&id=5308ab54&scoped=true&"
import script from "./LevelBar.vue?vue&type=script&lang=js&"
export * from "./LevelBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5308ab54",
  null
  
)

export default component.exports